import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type V2ViewMode = 'paged' | 'scroll';
export type V2ZoomFitMode = 'fitPage' | 'fitWidth' | 'custom';

/** V2 보기 모드(페이지 단위 / 연속 스크롤). localStorage에 지속된다. */
export const v2ViewModeAtom = atomWithStorage<V2ViewMode>(
  'pdfViewerV2ViewMode',
  'paged',
);

/** V2 줌 배율. fit-page 기준 1 = 100%. */
export const v2ZoomAtom = atom(1);

/** V2 줌 fit 모드. custom이 아니면 컨테이너 리사이즈 시 fit 배율을 유지한다. */
export const v2ZoomFitModeAtom = atom<V2ZoomFitMode>('fitPage');

/** V2 콘텐츠 영역(툴바/패널 제외) 크기 */
export const v2ContainerSizeAtom = atom({ width: 0, height: 0 });

/** V2 썸네일 패널 열림 상태 */
export const v2IsThumbnailPanelOpenAtom = atom(false);

/** 브라우저 Fullscreen API 활성 상태 */
export const v2IsFullscreenAtom = atom(false);

/** iOS 등 Fullscreen 미지원 환경의 몰입 모드(툴바 숨김) 상태 */
export const v2IsImmersiveAtom = atom(false);

/** 스크롤 모드에서 특정 페이지로 이동 요청(썸네일 클릭, 페이지 입력 등). 처리 후 null로 복귀 */
export const v2ScrollTargetPageAtom = atom<number | null>(null);
